import { EyeOutlined } from '@ant-design/icons';
import type { Order } from '@shop-monorepo/types';
import { Button } from 'antd';
import React from 'react';
import styled from 'styled-components';

import { formatPrice } from '../utils/currency';

import { OrderStatusTag } from './OrderStatusTag';

const DELIVERY_LABELS: Record<string, string> = {
  nova_poshta: 'Нова Пошта',
  ukrposhta: 'Укрпошта',
};

const Card = styled.div`
  background: #f8fafc;
  border: 1px solid #edf2f7;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

const Meta = styled.div`
  font-size: 13px;
  color: #64748b;
`;

interface OrderMobileCardProps {
  order: Order;
  onView: (id: number) => void;
}

export const OrderMobileCard: React.FC<OrderMobileCardProps> = ({ order, onView }) => (
  <Card>
    <Row>
      <span style={{ fontWeight: 700 }}>№{String(order.id).padStart(4, '0')}</span>
      <OrderStatusTag status={order.status} />
    </Row>
    <Row>
      <Meta>
        {formatPrice(order.total)} ·{' '}
        {DELIVERY_LABELS[order.delivery.provider] ?? order.delivery.provider}
      </Meta>
      <Button size="small" icon={<EyeOutlined />} onClick={() => onView(order.id)} />
    </Row>
  </Card>
);
